import React, { useState, useEffect } from "react";

/**
 * Renders a product image. If the primary `src` fails to load (e.g., the
 * branded photo hasn't been uploaded yet), it transparently falls back to
 * `fallback`. This lets editors drop files into /public/products/ without
 * touching code.
 */
export const ProductImage = ({ src, fallback, alt, className = "", ...rest }) => {
  const [current, setCurrent] = useState(src);

  // Reset when slug changes
  useEffect(() => {
    setCurrent(src);
  }, [src]);

  return (
    <img
      src={current}
      alt={alt}
      className={className}
      onError={() => {
        if (current !== fallback) setCurrent(fallback);
      }}
      {...rest}
    />
  );
};

export default ProductImage;
